export const portfolioSyncInterval = 60_000
